import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { MarketAdvertiserContextService } from './market-advertiser-context.service';
import { DataService } from './data.service';
import { StorageService } from 'src/app/services/storage.service';
import { Constants } from 'src/app/core/enums/constants.enum';
import { InventorySourceVO } from '../interfaces/vo/inventorySourceVO';

@Injectable({
  providedIn: 'root'
})
export class DashboardResolverService {

  constructor(private mktAdvCxtService: MarketAdvertiserContextService,
    private dataService: DataService,
    private storageService: StorageService) { }

  resolveAdvertiser(route: ActivatedRouteSnapshot) {
    let params = {
      id: route.paramMap.get('advertiserId') || route.queryParams.advertiserId,
      marketId: route.queryParamMap.get('marketId') // this is required for the endpoint
    };
    return this.mktAdvCxtService.getById(params.id, 'ADVERTISER', params.marketId).then(
      (response: any[]) => {
        // response will be the form of [{'marketId' : 'marketName'}] : [{'1' : 'turn'}]
        let advertiserInfo;
        if (response && response.length) {
          advertiserInfo = {
            ...params,
            name: response[0][params.id]
          }
          if (advertiserInfo.marketTimeZone) {
            this.storageService.setItem(Constants.MARKET_TIMEZONE, advertiserInfo.marketTimeZone);
          }
        }
        return advertiserInfo;
      }
    );
  }

  resolveCurrentInvSources(route: ActivatedRouteSnapshot) {
    let params = {
      marketId: route.queryParamMap.get('marketId')
    };
    return this.dataService.getDealExchanges(params.marketId).then((currentInvs: Array<InventorySourceVO>) => {
      return currentInvs.map(inv => ({
        label: inv.description,
        name: inv.id
      }));
    });
  }

  resolveMarket(route: ActivatedRouteSnapshot) {
    let params = {
      id: route.paramMap.get('marketId')
    };
    return this.mktAdvCxtService.getById(params.id, 'MARKET').then(
      (response: any[]) => {
        // response will be the form of [{'advertiserId' : 'advertiserName'}] : [{'123' : 'Paypal Test'}]
        let marketInfo;
        if (response && response.length) {
          marketInfo = {
            ...params,
            name: response[0][params.id]
          }
        }
        return marketInfo;
      }
    );
  }

  resolvePlanner(route: ActivatedRouteSnapshot) {
    return this.dataService.getPlan(route.paramMap.get('plannerId'));
  }

  resolvePlannerDetails(route: ActivatedRouteSnapshot) {
    return this.dataService.getPlanDetails(route.paramMap.get('plannerId'));
  }

  resolvePlannerDefault(route: ActivatedRouteSnapshot) {
    let params = {
      advertiserId: route.queryParamMap.get('advertiserId') || route.queryParams.advertiserId,
      marketId: route.queryParamMap.get('marketId') || route.queryParams.marketId
    };
    return this.dataService.getPlanDefaults(params);
  }

  resolvePlannerResult(route: ActivatedRouteSnapshot) {
    let promiseAll = [],
      planId = route.paramMap.get('plannerId');

    promiseAll.push(this.dataService.getPlanResult(planId));
    promiseAll.push(this.dataService.getPlanForecastBluePrint(planId));

    return Promise.all(promiseAll);
  }

}
